import React from "react";

const RepoDropdown = ({ reposList, selectedRepoUrl, onSelectRepo }) => {
  return (
    reposList.length > 0 && (
      <div style={styles.dropdownContainer}>
        <select
          onChange={(e) => onSelectRepo(e.target.value)}
          style={styles.select}
          value={selectedRepoUrl}
        >
          <option value="" disabled>
            Select a repo
          </option>
          {reposList.map((repo, index) => (
            <option key={index} value={repo.url}>
              {repo.name}
            </option>
          ))}
        </select>
      </div>
    )
  );
};

const styles = {
  dropdownContainer: {
    marginTop: "10px",
  },
  select: {
    margin: "5px",
    padding: "10px",
    fontSize: "14px",
  },
};

export default RepoDropdown;
